import { Grid } from '@mui/material';
import { IconDocument1 } from 'assets/img';
import { getLegalDocuments, WEBAPP_BRAND } from 'config';
import { Header, LwButton, Page, Toolbox } from 'redesign';

const Legal = () => {
  const documents = getLegalDocuments(WEBAPP_BRAND);
  return (
    <Page
      header={
        <Header
          subheaderText="Hier vind je alle juridische documenten"
          titleText="Juridische documenten"
        />
      }
      toolbox={<Toolbox />}
    >
      <Grid container spacing={8}>
        <Grid item xs={12} md={12} lg={4} mt={4}>
          <LwButton
            color="secondary"
            to={documents.termsOfUse}
            target="_blank"
            startIcon={<IconDocument1 />}
            iconVariant="outlined"
            iconColorMode="fill"
          >
            Gebruikersvoorwaarden
          </LwButton>
        </Grid>
        <Grid item xs={12} md={12} lg={4} mt={4}>
          <LwButton
            color="secondary"
            to={documents.privacyStatement}
            target="_blank"
            startIcon={<IconDocument1 />}
            iconVariant="outlined"
            iconColorMode="fill"
          >
            Privacy statement
          </LwButton>
        </Grid>
        {WEBAPP_BRAND !== 'opus' ? (
          <Grid item xs={12} md={12} lg={4} mt={4}>
            <LwButton
              color="secondary"
              to={documents.contractTemplate}
              target="_blank"
              startIcon={<IconDocument1 />}
              iconVariant="outlined"
              iconColorMode="fill"
            >
              Modelovereenkomst
            </LwButton>
          </Grid>
        ) : null}
      </Grid>
    </Page>
  );
};

export { Legal };
